const transformDateToYMD = date => {
    const yyyy = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    return `${yyyy}-${ m >= 10 ? m : ( '0' + m ) }-${ d >= 10 ? d : ( '0' + d ) }`;
};


export default {
    transformDateToYMD
}